import { render, staticRenderFns } from "./StatusTemp.vue?vue&type=template&id=fef54ed4&"
import script from "./StatusTemp.vue?vue&type=script&lang=js&"
export * from "./StatusTemp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports